import { UserApi } from 'api/api'
import { useQuery } from 'react-query'
import { LeagueItem } from 'types/types'

export const useGetAllMiniLeagues = (gameId: number, pin?: string) => {
  const { data, isLoading, isError, error, refetch } = useQuery<{
    public: LeagueItem[]
    private: LeagueItem[]
  }>(['allMiniLeagues', pin], () => UserApi.getAllMiniLeagues(gameId, pin))
  return { data, isLoading, isError, error, refetch }
}
